<template>
  <div :key="componentKey" :data-testid="TEST_ID.PROFILE.ROOT">
    <el-row class="container" v-if="perfil !== undefined">
      <el-col :span="24">
        <!-- Header página -->
        <el-row>
          <el-col :xs="8" :sm="10" :md="12" :lg="14" :xl="16">
            <div class="title" :data-testid="TEST_ID.PROFILE.TITLE">{{ $t('PERFIL_perfil') }}</div>
          </el-col>
          <el-col :xs="16" :sm="14" :md="12" :lg="10" :xl="8" style="text-align:right">
            <router-link :to="{ name: 'Solicitud Perfil'}">
              <el-button
                :data-testid="TEST_ID.PROFILE.EDIT_BUTTON"
                type="primary"
                icon="Edit"
                size="default"
                round
              >{{ $t('PERFIL_editar') }}</el-button>
            </router-link>
          </el-col>
        </el-row>

        <!-- Seccion empresa -->
        <el-row v-if="perfil.Codigo" class="section">
          <div class="section__title">{{ $t('PERFIL_empresa') }}</div>
          <el-row>
            <div class="card_list card_list--empresa">
              <div class="card_list_item">
                <el-card>
                  <el-row>
                    <el-col v-bind:class="`img_container_responsive ${perfil.Imagen == null ? 'no-img' : ''}`" :span="24">
                      <img
                        class="img_profile"
                        :src="'data:image/png;base64,' + perfil.Imagen"
                        alt
                      />
                    </el-col>
                    <el-col class="col-empresa" :span="16">
                      <el-row :gutter="20">
                        <el-col class="col-empresa" :span="6">
                          <div class="label">{{ $t('PERFIL_razon_social') }}</div>
                        </el-col>
                        <el-col class="col-empresa" :span="15">
                          <div class="label_value">{{perfil.Empresa.RazonSocial}}</div>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col class="col-empresa" :span="6">
                          <div class="label">{{ $t('PERFIL_domicilio') }}</div>
                        </el-col>
                        <el-col class="col-empresa" :span="15">
                          <div class="label_value">{{perfil.Empresa.Domicilio}}</div>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20" :data-testid="TEST_ID.PROFILE.EMPRESA_LOCALIDAD_ROW">
                        <el-col class="col-empresa" :span="6">
                          <div class="label">{{ $t('PERFIL_localidad') }}</div>
                        </el-col>
                        <el-col class="col-empresa" :span="15">
                          <div class="label_value">{{perfil.Empresa.Localidad}}</div>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20" :data-testid="TEST_ID.PROFILE.EMPRESA_CP_ROW">
                        <el-col class="col-empresa" :span="6">
                          <div class="label">{{ $t('PERFIL_cp') }}</div>
                        </el-col>
                        <el-col class="col-empresa" :span="15">
                          <div class="label_value">{{perfil.Empresa.CodigoPostal}}</div>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col class="col-empresa" :span="6">
                          <div class="label">{{ $t('PERFIL_pcia_estado') }}</div>
                        </el-col>
                        <el-col class="col-empresa" :span="15">
                          <div class="label_value">{{ $filters.defaultEmpty(perfil.Empresa.ProvinciaEstado) }}</div>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col class="col-empresa" :span="6">
                          <div class="label">{{ $t('PERFIL_pais') }}</div>
                        </el-col>
                        <el-col class="col-empresa" :span="15">
                          <div class="label_value">{{perfil.Empresa.Pais}}</div>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col class="col-empresa" :span="6">
                          <div
                            class="label"
                          >{{ $t('PERFIL_lineas') }}</div>
                        </el-col>
                        <el-col v-if="!perfil.Empresa.LineasVenta.length" class="col-empresa" :span="15">
                          <div class="label_value">
                            <label>---</label> 
                          </div>
                        </el-col>
                        <el-col v-if="perfil.Empresa.LineasVenta.length" class="col-empresa" :span="15">
                          <el-tooltip
                            class="item"
                            effect="dark"
                            placement="top-start"
                            :content="linea.Descripcion"
                            v-for="(linea, index) in perfil.Empresa.LineasVenta"
                            :key="index">
                            <div
                              style="cursor: pointer;"
                              class="label_value">
                              {{perfil.Empresa.LineasVenta.lenght == 0?"---": lineaVende(index,perfil.Empresa.LineasVenta)}}
                            </div>
                          </el-tooltip>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col v-bind:class="`img_container ${perfil.Imagen == null ? 'no-img' : ''}`" :span="8">
                      <img
                        class="img_profile"
                        :src="'data:image/png;base64,' + perfil.Imagen"
                        alt
                      />
                    </el-col>
                  </el-row>
                </el-card>
              </div>
            </div>
          </el-row>
        </el-row>

        <el-row v-else class="empty_state">
          <div>{{ $t('PERFIL_empty_state')}}</div>
        </el-row>

        <!-- Telefono email -->
        <el-row v-if="perfil.Codigo" class="section">
          <div class="section__title">{{ $t('PERFIL_tel_mail') }}</div>
          <div class="card_list">
            <div
              class="card_list_item"
              v-for="(contacto, index) in perfil.Empresa.Contactos"
              :key="index">
              <el-card>
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="6" :md="7" :lg="7" :xl="7">
                    <div class="label">{{ $t('PERFIL_nro_mail') }}</div>
                  </el-col>
                  <el-col :xs="24" :sm="18" :md="17" :lg="17" :xl="17">
                    <div class="label_value">{{contacto.NumeroEmail}}</div>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :xs="5" :sm="6" :md="7" :lg="7" :xl="7">
                    <div class="label">{{ $t('PERFIL_area') }}</div>
                  </el-col>
                  <el-col :xs="19" :sm="18" :md="17" :lg="17" :xl="17">
                    <div class="label_value">{{ $filters.defaultEmpty(contacto.Area) }}</div>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :xs="5" :sm="6" :md="7" :lg="7" :xl="7">
                    <div class="label">{{ $t('PERFIL_tipo') }}</div>
                  </el-col>
                  <el-col :xs="19" :sm="18" :md="17" :lg="17" :xl="17">
                    <div class="label_value">{{contacto.Tipo}}</div>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="6" :md="7" :lg="7" :xl="7">
                    <div class="label">{{ $t('PERFIL_usado_para') }}</div>
                  </el-col>
                  <el-col :xs="24" :sm="18" :md="17" :lg="17" :xl="17">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                      :content="usado.Descripcion"
                      v-for="(usado, index) in contacto.UsadoPara"
                      :key="index"
                      style="cursor: pointer;"
                    >
                      <div class="label_value">{{usadoPara(index,contacto.UsadoPara)}}</div>
                    </el-tooltip>
                  </el-col>
                </el-row>
              </el-card>
            </div>
          </div>
        </el-row>

        <!-- Direcciones -->
        <!-- :style="{width:perfil.Sucursales.length == 1?'50%':'none'}"-->
        <el-row v-if="perfil.Codigo" class="section">
          <div class="section__title">{{ $t('PERFIL_direcciones') }}</div>
          <div class="card_list">
            <div
              value
              class="card_list_item direcciones"
              v-for="(sucursal, index) in perfil.Sucursales"
              :key="index"
            >
              <el-card>
                <div>
                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
                      <div class="label">{{ $t('PERFIL_razon_social') }}</div>
                    </el-col>
                    <el-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17">
                      <div class="label_value">{{sucursal.RazonSocial}}</div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
                      <div class="label">{{ $t('PERFIL_domicilio') }}</div>
                    </el-col>
                    <el-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17">
                      <div class="label_value">{{sucursal.Domicilio}}</div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20" :data-testid="TEST_ID.PROFILE.DIRECCION_LOCALIDAD_ROW">
                    <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
                      <div class="label">{{ $t('PERFIL_localidad') }}</div>
                    </el-col>
                    <el-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17">
                      <div class="label_value">{{sucursal.Localidad}}</div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20" :data-testid="TEST_ID.PROFILE.DIRECCION_CP_ROW">
                    <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
                      <div class="label">{{ $t('PERFIL_cp') }}</div>
                    </el-col>
                    <el-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17">
                      <div class="label_value">{{sucursal.CodigoPostal}}</div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="7">
                      <div class="label">{{ $t('PERFIL_provincia') }}</div>
                    </el-col>
                    <el-col :xs="17" :sm="7" :md="7" :lg="7" :xl="7">
                      <div class="label_value">{{sucursal.Provincia}}</div>
                    </el-col>
                    <el-col :xs="7" :sm="5" :md="5" :lg="5" :xl="5">
                      <div class="label">{{ $t('PERFIL_pcia_clave')}}</div>
                    </el-col>
                    <el-col :xs="17" :sm="5" :md="5" :lg="5" :xl="5">
                      <div class="label_value">{{ $filters.defaultEmpty(sucursal.CodigoProvincia) }}</div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
                      <div class="label">{{ $t('PERFIL_usado_para') }}</div>
                    </el-col>
                    <el-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        placement="top-start"
                        :content="usado.Descripcion"
                        v-for="(usado, index) in sucursal.UsadoPara"
                        :key="index"
                        style="cursor: pointer;"
                      >
                        <div class="label_value">{{usadoPara(index,sucursal.UsadoPara)}}</div>
                      </el-tooltip>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :xs="18" :sm="16" :md="14" :lg="14" :xl="11">
                      <el-tooltip
                        v-if="!sucursal.Contactos.length"
                        class="item"
                        effect="dark"
                        placement="top-start"
                        content="No posee telefonos asociados"
                      >
                        <div class="telefonos_asoc_link">{{ $t('PERFIL_tel_direccion') }}</div>
                      </el-tooltip>

                      <div
                        v-if="sucursal.Contactos.length"
                        class="telefonos_asoc_link"
                        @click="openPhoneAsocModal(sucursal.Contactos)"
                      >{{ $t('PERFIL_tel_direccion') }}</div>
                    </el-col>
                  </el-row>
                </div>
              </el-card>
            </div>
          </div>
        </el-row>
      </el-col>
    </el-row>

    <!-- Modal telefonos asociados -->
    <el-dialog :title="$t('PERFIL_tel_asoc')" v-model="modalOpened" :data-testid="TEST_ID.PROFILE.PHONE_MODAL_ROOT">
      <span>
        <div class="card_list">
          <div class="card_list_item_modal" v-for="(contacto, index) in modalContacts" :key="index">
            <el-card>
              <el-row :gutter="20">
                <el-col class="col-card-modal" :xs="10" :sm="9" :md="8" :lg="7" :xl="6">
                  <div class="label">{{ $t('PERFIL_nro_mail') }}</div>
                </el-col>
                <el-col class="col-card-modal" :span="14">
                  <div class="label_value">{{contacto.NumeroEmail}}</div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col class="col-card-modal" :xs="10" :sm="9" :md="8" :lg="7" :xl="6">
                  <div class="label">{{ $t('PERFIL_area') }}</div>
                </el-col>
                <el-col class="col-card-modal" :span="14">
                  <div class="label_value">{{ $filters.defaultEmpty(contacto.Area) }}</div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col class="col-card-modal" :xs="10" :sm="9" :md="8" :lg="7" :xl="6">
                  <div class="label">{{ $t('PERFIL_tipo') }}</div>
                </el-col>
                <el-col class="col-card-modal" :span="14">
                  <div class="label_value">{{contacto.Tipo}}</div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col class="col-card-modal" :xs="10" :sm="9" :md="8" :lg="7" :xl="6">
                  <div class="label">{{ $t('PERFIL_usado_para') }}</div>
                </el-col>
                <el-col class="col-card-modal" :span="14">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    placement="top-start"
                    :content="usado.Descripcion"
                    v-for="(usado, index) in contacto.UsadoPara"
                    :key="index"
                    style="cursor: pointer;">
                    <div class="label_value">{{usadoPara(index,contacto.UsadoPara)}}</div>
                  </el-tooltip>
                </el-col>
              </el-row>
            </el-card>
          </div>
        </div>
      </span>
      <template #footer>
        <span class="dialog-footer">
          <el-button style="padding:10px 20px !important;" type="primary" @click="modalOpened = false" round>{{ $t('GENERAL_volver') }}</el-button>
        </span>
      </template> 
    </el-dialog>

    <!-- Modal telefonos asociados -->

    <!-- <Modal v-if="modalOpened">
      <template v-slot:header>
        <div class="modal_title">{{ $t('PERFIL_tel_asoc') }}</div>
      </template>
      <template v-slot:body>
        <div class="modal_body">
            <div class="card_list">
              <div class="card_list_item_modal" v-for="(contacto, index) in modalContacts" :key="index">
                <el-card>
                  <el-row :gutter="20">
                    <el-col class="col-card-modal" :xs="10" :sm="9" :md="8" :lg="7" :xl="6">
                      <div class="label">{{ $t('PERFIL_nro_mail') }}</div>
                    </el-col>
                    <el-col class="col-card-modal" :span="14">
                      <div class="label_value">{{contacto.NumeroEmail}}</div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col class="col-card-modal" :xs="10" :sm="9" :md="8" :lg="7" :xl="6">
                      <div class="label">{{ $t('PERFIL_area') }}</div>
                    </el-col>
                    <el-col class="col-card-modal" :span="14">
                      <div class="label_value">{{ $filters.defaultEmpty(contacto.Area) }}</div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col class="col-card-modal" :xs="10" :sm="9" :md="8" :lg="7" :xl="6">
                      <div class="label">{{ $t('PERFIL_tipo') }}</div>
                    </el-col>
                    <el-col class="col-card-modal" :span="14">
                      <div class="label_value">{{contacto.Tipo}}</div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col class="col-card-modal" :xs="10" :sm="9" :md="8" :lg="7" :xl="6">
                      <div class="label">{{ $t('PERFIL_usado_para') }}</div>
                    </el-col>
                    <el-col class="col-card-modal" :span="14">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        placement="top-start"
                        :content="usado.Descripcion"
                        v-for="(usado, index) in contacto.UsadoPara"
                        :key="index"
                        style="cursor: pointer;">
                        <div class="label_value">{{usadoPara(index,contacto.UsadoPara)}}</div>
                      </el-tooltip>
                    </el-col>
                  </el-row>
                </el-card>
              </div>
            </div>

        </div>
      </template>
      <template v-slot:footer>
        <div class="btn-container">
          <el-button type="primary" @click="closeModal">{{ $t('GENERAL_volver') }}</el-button>
        </div>
      </template>
    </Modal> -->
  </div>
</template>

<script>

import { mapState } from "vuex";
import TEST_ID from '@/testIds.json'

export default {
  name: 'PerfilView',
  data() {
    return {
      TEST_ID,
      modalOpened: false,
      modalContacts: [],
      componentKey: 0
    };
  },
  created() {
    this.$store.dispatch("perfil/getPerfil");
  },
  computed: {
    ...mapState({
      perfil: state => state.perfil.perfil,
      idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario
    })
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;  
    },
    openPhoneAsocModal(contactos) {
      this.modalOpened = true;
      this.modalContacts = contactos;
    },
    closeModal() {
      this.modalOpened = false;
    },
    lineaVende(index, lineas) {
      let str = "";

        str += lineas[index].Codigo;
        str += index == lineas.length - 1 ? " " : "-";

      return str;
    },
    usadoPara(index, usados) {
      let str = "";
      str += usados[index].Codigo;
      str += index == usados.length - 1 ? " " : "-";
      return str;
    }
  }
};
</script>


<style scoped>

.card_list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  grid-gap: 1rem;
  align-items: start;
}

.card_list--empresa {
  grid-template-columns: 1fr;
  width: 100%;
}

.card_list_item {
  position: relative;
  text-align: left;
  align-self: start;
}
.card_list_item_modal {
  position: relative;
  text-align: left;
}

.img_container,
.img_container_responsive {
  text-align: right;
}

.img_container.no-img,
.img_container_responsive.no-img {
  background-color: #efefef;
  height: 150px;
}

.img_container_responsive {
  display: none;
}

.img_profile {
  height: 150px;
}

.container {
  display: flex;
  padding: 20px 40px;
}

@media (max-width: 600px) {
  .container {
    padding: 20px 10px;
  }
  .col-empresa {
    flex: 1;
    width: 100% !important;
  }
  .img_container_responsive {
    display: block;
    text-align: center !important;
  }
  .img_container {
    display: none;
  }
  .direccion {
    width: 100% !important;
  }
  .col-card-modal {
    width: 100%;
  }
  .card_list_item_modal {
    width: 70% !important;
  }
 
}
@media (max-width: 786px){
  .card_list_item_modal {
    width: 100%;
  }

}

.title {
  font-size: 22px;
  font-weight: bold;
  text-align: left;
  color: var(--main-color);
}
.section {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 15px 0;
}

.section > .el-row,
.section > .section__title {
  width: 100%;
}

.section__title {
  font-size: 20px;
  line-height: 23px;
  color: var(--main-color);
  text-align: left;
}
.cards_container {
  display: flex;
  flex-wrap: wrap;
  margin-top: 15px;
  width: 100%;
}
.card_empresa {
  flex: 1;
  text-align: left;
}
.label {
  font-size: 14px;
  line-height: 25px;
  color: #555555;
  display: inline-block;
}
.label_value {
  font-size: 14px;
  font-weight: bold;
  line-height: 25px;
  color: #000000;
  display: inline-block;
}

.lineas {
  display: flex;
  flex-direction: column;
}
.card_nro_mail {
  text-align: left;
  flex: 1 0 350px;
  margin-bottom: 15px;
  max-width: 50%;
}
.telefonos_asoc_link {
  line-height: 25px;
  vertical-align: bottom !important;
  color: var(--main-color);
  cursor: pointer;
  margin-top: 5px;
}
.button {
  position: fixed;
  bottom: 40px;
  right: 40px;
}
.modal_title {
  font-size: 22px;
  font-weight: bold;
  text-align: left;
  color: var(--main-color);
  margin-bottom: 20px;
  text-align: left;
}
.modal_body {
  /*display: flex; */
  border-top: 1px solid #ececec;
  border-bottom: 1px solid #ececec;
  flex-wrap: wrap;
}

.empty_state {
  display: flex;
  height: 50vh;
  align-items: center;
  justify-content: center;
  color: #999;
}
</style>
